import { Record } from 'immutable';
import moment from 'moment';
import { 
  actionTypes, 
  fetchAppointmentsActions,
  getStaffListActions, 
  getStaffAvailabilityActions, 
  saveAppointmentActions,
} from './mySchedule.actions';
import * as api from '../../api';

export const MyScheduleState = Record({
  appointments: [],
  fetch: api.ApiCallState({}),
  date: moment().startOf('day'),
  staffListState: api.ApiCallState({}),
  staffAvailabilityState: api.ApiCallState({}),
  submitAppointmentState: api.ApiCallState({}),
});

export const myScheduleReducer = (initialState = new MyScheduleState(), action) => {
  var state = initialState.set('fetch',
    api.apiCallReducer(initialState.get('fetch'), action, fetchAppointmentsActions));

  state = state.set('staffListState',
    api.apiCallReducer(state.get('staffListState'), action, getStaffListActions));

  state = state.set('staffAvailabilityState',
    api.apiCallReducer(state.get('staffAvailabilityState'), action, getStaffAvailabilityActions));

  state = state.set('submitAppointmentState',
    api.apiCallReducer(state.get('submitAppointmentState'), action, saveAppointmentActions));


  switch (action.type) {
    case actionTypes.FETCH_APPOINTMENT_BEGIN:
      return state.set('appointments', []);
    case actionTypes.FETCH_APPOINTMENT_SUCCESS:
      return state.set('appointments', action.data);
    case actionTypes.CHANGE_DATE:
      return state.set('date', action.date);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/scheduler/mySchedule/mySchedule.reducer.js